export default {};

export const keyToColumnnMap = {
  code: 'ID',
  name: 'Name',
  status: 'Status',
  description: 'Description',
  partNumber: 'Part Number',
  supplier: 'Supplier',
  vendor: 'Vendor',
  quantity: 'Quantity',
  quantityAllocated: 'Quantity Allocated',
  units: 'Unit Type',
  quantityThreshold: 'Quantity Threshold',
  costcode: 'Cost Code',
};

export const INITIAL_SORT_FILTERS = {
  filters: {
    status: ['1'],
  },
  sorter: {},
};

export const FULL_EXPORT_ORDER = [
  'code',
  'name',
  'active',
  'groupId',
  'description',
  'partNumber',
  'supplier',
  'vendor',
  'cost',
  'markup',
  'price',
  'labourCost',
  'labourMarkup',
  'labourPrice',
  'quantity',
  'quantityAllocated',
  'quantityAvailable',
  'quantityThreshold',
  'units',
  'costcode',
  'locations',
];
